module.exports = __webpack_public_path__ + "img/CliEyeSet2.621dd11e.jpg";